import { useSceneObjects } from '@hooks/useSceneObjects'
import { Item3D } from './Item/Item3D'
import { LinkedItem3D } from './linked/LinkedItem3D'

export function ObjectsManager3D() {
  const sceneObjects = useSceneObjects()

  return (
    <>
      {sceneObjects?.map((obj) => {
        if (!obj) return null
        switch (obj.type) {
          case 'items':
            return (
              <Item3D
                key={obj.id}
                {...obj}
              />
            )
          case 'linkedItem': {
            return (
              <LinkedItem3D
                key={obj.id}
                {...obj}
              />
            )
          }
          default:
            return null
        }
      })}
      {/* <OBBVisualizer3D /> */}
      <mesh
        visible={false}
        position={[0, 1000000, 0]}
      >
        <boxGeometry args={[1, 1, 1]}></boxGeometry>
      </mesh>
    </>
  )
}
